import { useEffect, useState } from "react";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import "./CustomDropdown.scss";

interface CustomDropdownProps {
	options: { name: string; code: string }[];
	placeholder: string;
	onSelect: (selected: any) => void;
	selectedOption: any;
}

const CustomDropdown: React.FC<CustomDropdownProps> = ({
	options,
	onSelect,
	placeholder,
	selectedOption,
}) => {
	const [selectedValue, setSelectedValue] = useState<any>();

	useEffect(() => {
		setSelectedValue(selectedOption);
	}, [selectedOption]);

	useEffect(() => {
		setSelectedValue(selectedOption);
	}, [selectedOption]);

	const handleChange = (e: DropdownChangeEvent) => {
		const selectedValue = e.value;
		setSelectedValue(selectedValue);
		onSelect(selectedValue);
	};

	return (
		<Dropdown
			value={selectedValue}
			onChange={handleChange}
			options={options}
			optionLabel="name"
			placeholder={placeholder}
			className="w-full custom-dropdown h-9"
		/>
	);
};

export default CustomDropdown;
